module.exports = __webpack_public_path__ + "img/modelbg.615e51c1.png";